const Message = () =>{
    return(
        <h1>Message</h1>
    )
}

export default Message;